var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"t-table-v2__row",class:[{
    't-table-v2__row--highlighted': _vm.highlighted,
    't-table-v2__row--expanded': _vm.expanded
  }],on:{"click":function($event){return _vm.$emit('rowClick', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }